<template>
    <div class="warranty-status-piechart">
        <div class="row mt-4">
            <div class="cols-sm-12 col-md-12 col-lg-12">
                <h3 class="mb-4">
                    Reseller<br />
                    <span class="bg-secondary text-white px-4 pt-2 pb-1 inline-block">{{ totalResellers }}</span>
                </h3>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <ul class="reset has-color-box">
                            <li v-for="(item, index) in allData" :key="'reseller-depot-' + index">
                                <span class="color-box" :style="`background-color: ${item.depot_color}`"> </span
                                ><span class="text-semibold">{{ item.depot_name }} - {{ item.resellers.length }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <apexchart v-if="!loading" type="pie" height="300" :options="pieChartOptions" :series="pieSeries" />
                        <div v-else class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import moment from 'moment';
export default {
    name: 'RepairStatusPiechart',
    components: {
        apexchart: VueApexCharts
    },
    props: {
        startDate: {
            type: [Date, String],
            required: false,
            default: null
        },
        endDate: {
            type: [Date, String],
            required: false,
            default: null
        }
    },
    computed: {
        pieSeries() {
            return this.counts;
        }
    },
    data() {
        return {
            allData: [],
            genericColorCodes: ['#e70413', '#146081', '#000000'],
            loading: true,
            totalResellers: 0,
            counts: [],
            // Pie Chart Series and Options
            pieChartOptions: {
                chart: {
                    type: 'bar'
                },
                labels: [],
                colors: [],
                legend: {
                    show: false,
                    position: 'right'
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        },
                        fill: {
                            color: '#FFFFFF' // black on hover
                        }
                    }
                },

                dataLabels: {
                    enabled: true,
                    offsetX: 10,
                    offsetY: 0,
                    formatter: function (val, opts) {
                        return opts.w.globals.series[opts.seriesIndex];
                    },
                    style: {
                        colors: ['#ffffff'],
                        fontSize: '16px',
                        fontWeight: 'bold'
                    },
                    dropShadow: {
                        enabled: false
                    }
                }
            }
        };
    },
    mounted() {
        this.getWarrantyStats();
        console.log(this.startDate, this.endDate);
    },
    methods: {
        getWarrantyStats() {
            let url = `${Env.baseUrl}/superadmin/reseller/list-all-depot-based-resellers`;
            if (this.startDate && this.endDate) {
                const startDateStr = typeof this.startDate === 'string' ? this.startDate : moment(this.startDate).format('YYYY-MM-DD');
                const endDateStr = typeof this.endDate === 'string' ? this.endDate : moment(this.endDate).format('YYYY-MM-DD');
                url += `?startDate=${startDateStr}&endDate=${endDateStr}`;
            }
            AuthApis.getApi(url)
                .then((res) => {
                    this.totalResellers = 0;
                    this.counts = [];
                    this.pieChartOptions.labels = [];
                    this.pieChartOptions.colors = [];
                    this.allData = res.data.payload;
                    for (let key in res.data.payload) {
                        this.totalResellers += res.data.payload[key].resellers.length;
                        this.counts.push(res.data.payload[key].resellers.length);
                        this.pieChartOptions.labels.push(res.data.payload[key].depot_name);
                        this.pieChartOptions.colors.push(res.data.payload[key].depot_color);
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
        },

        getRandomDarkColor() {
            // Generate RGB values between 0 and 100 (dark range)
            const r = Math.floor(Math.random() * 100);
            const g = Math.floor(Math.random() * 100);
            const b = Math.floor(Math.random() * 100);
            const toHex = (val) => val.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        }
    }
};
</script>
